var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDesign13(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 202,
    viewBox: "0 0 166 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 25C0 11.1929 11.1929 0 25 0H141C154.807 0 166 11.1929 166 25V177C166 190.807 154.807 202 141 202H25C11.1929 202 0 190.807 0 177V25Z",
    fill: "url(#paint0_linear_152_126)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_152_126",
    x1: 87.5,
    y1: 80,
    x2: 83,
    y2: 202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2778F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91BDFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesign13);
export default __webpack_public_path__ + "static/media/design13.ac17f9beacab52b20a8d93f7c75d417a.svg";
export { ForwardRef as ReactComponent };